import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { bundleFoldFor } from '~/components/AiSearchChips/bundlesAsServices';
export const foldAgreementBundlesIntoServices = bundleFoldFor((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { bundles: _foldedIntoServices } = _ref1, rest = _object_without_properties(_ref1, [
        "bundles"
    ]), [services] = _rest;
    return _object_spread_props(_object_spread({}, rest), {
        services: {
            any: services
        }
    });
});
